import * as React from 'react';
import { Checkbox } from 'semantic-ui-react';

interface IRadioCheckBoxComponentProps {
}
interface IRadioCheckBoxComponentState {
    ischecked: boolean;
}


export class RadioCheckBoxComponent extends React.Component<IRadioCheckBoxComponentProps, IRadioCheckBoxComponentState>{
    constructor(props: IRadioCheckBoxComponentProps) {
        super(props);
        this.state = {
            ischecked: false
        }
    }
    public render(){
        return (
            <Checkbox radio checked={this.state.ischecked} onClick={() => this.checkboxUpdate()} />
        );
    }

    private checkboxUpdate() {
        this.setState({
            ischecked: !this.state.ischecked
        });
    }
}